import { render, staticRenderFns } from "./awardsDetail.vue?vue&type=template&id=4762aefb&scoped=true"
import script from "./awardsDetail.vue?vue&type=script&lang=js"
export * from "./awardsDetail.vue?vue&type=script&lang=js"
import style0 from "./awardsDetail.vue?vue&type=style&index=0&id=4762aefb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4762aefb",
  null
  
)

export default component.exports